/** Create ingredients list with uncompleted items and list with completed items.
 * @method
 * @param { Object } grocery server responce
 * @returns { Object } with completedItems and uncompletedIngredients
 */
const separateCompletedItems = (grocery) => {
  const completedItems = [];
  const uncompletedIngredients = [];

  if (grocery.ingredients.length === 1) {
    delete grocery.ingredients[0].name;
  }

  for (let ingredient of grocery.ingredients) {
    const uncompletedItems = [];
    for (let item of ingredient.items) {
      item = { ...item, ingredientId: ingredient.id, groceryId: grocery.id };
      if (item.check) {
        completedItems.push(item);
      } else {
        uncompletedItems.push(item);
      }
    }
    uncompletedIngredients.push({ ...ingredient, items: uncompletedItems });
  }

  return { uncompletedIngredients, completedItems };
};

export default separateCompletedItems;
